import * as React from 'react';
import { cn } from '@/lib/utils';

const CardMetricHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-card-metric-header', 'mb-1', className)}
    {...props}
  />
));
CardMetricHeader.displayName = 'CardMetricHeader';

const CardMetricTitle = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-card-metric-title',
      // Estilos base
      'mb-0 text-xs font-light leading-snug text-[#8894AC]',
      className
    )}
    {...props}
  />
));
CardMetricTitle.displayName = 'CardMetricTitle';

const CardMetricBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-card-metric-body',
      // Estilos base
      'flex justify-center gap-7',
      className
    )}
    {...props}
  />
));
CardMetricBody.displayName = 'CardMetricBody';

const CardMetricValue = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-card-metric-value',
      // Estilos base
      'mb-0 whitespace-nowrap text-base font-bold text-primary-dark',
      className
    )}
    {...props}
  />
));
CardMetricValue.displayName = 'CardMetricValue';

const CardMetricWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-card-metric-wrapper',
      // Estilo base
      'flex flex-wrap gap-5',
      '[&>*]:flex-grow [&>*]:basis-0',
      className
    )}
    {...props}
  />
));
CardMetricWrapper.displayName = 'CardMetricWrapper';

const CardMetric = React.forwardRef(({ className, variant, clickable, children, ...props }, ref) => {
  const baseClasses = cn('bg-white rounded-lg shadow-dropshadow-sm', 'p-3 text-center min-w-[144px] border border-solid border-transparent', clickable && 'cursor-pointer');

  const variantClasses = {
    light: 'bg-gradient-to-br from-white via-white to-gray-100 [&_.c-card-metric-value]:text-primary',
    monochrome: 'bg-primary-lightest [&_.c-card-metric-title]:text-primary [&_.c-card-metric-value]:text-primary',
    primary: 'border-primary [&_.c-card-metric-title]:text-primary',
    secondary: 'border-secondary [&_.c-card-metric-title]:text-secondary',
    success: 'border-[#23CA88] [&_.c-card-metric-title]:text-[#23CA88]',
    danger: 'border-danger [&_.c-card-metric-title]:text-danger',
    warning: 'border-third [&_.c-card-metric-title]:text-third',
    info: 'border-[#32C9D3] [&_.c-card-metric-title]:text-[#32C9D3]',
    t2: 'p-0 text-left min-w-0 border-0 shadow-none relative [&_.c-card-metric-body]:justify-start',
    outline: cn(
      'rounded-sm border-bright p-2.5 shadow-none text-left', // p: 8px 20px
      '[&_.c-card-metric-body]:justify-start',
      '[&_.c-card-metric-value]:text-primary-dark [&_.c-card-metric-value_svg]:align-sub [&_.c-card-metric-value_svg]:w-5 [&_.c-card-metric-value_svg]:stroke-primary'
    ),
    'large-text': cn(
      'flex flex-col gap-4',
      '[&_.c-card-metric-header]:basis-0 [&_.c-card-metric-header]:flex-grow [&_.c-card-metric-header]:mb-0',
      '[&_.c-card-metric-body]:basis-0 [&_.c-card-metric-body]:flex-grow',
      '[&_.c-card-metric-title]:text-black [&_.c-card-metric-title]:text-base [&_.c-card-metric-title]:font-bold [&_.c-card-metric-title]:text-left',
      '[&_.c-card-metric-value]:text-neutral-darker [&_.c-card-metric-value]:text-[28px]'
    )
  };

  const combinedClasses = cn(
    baseClasses,
    // Aplica classes apenas se o variant existir no mapa
    variant && variantClasses[variant],
    className
  );

  return (
    <div
      ref={ref}
      className={combinedClasses}
      {...props}
    >
      {children}
    </div>
  );
});
CardMetric.displayName = 'CardMetric';

export { CardMetric, CardMetricWrapper, CardMetricHeader, CardMetricTitle, CardMetricBody, CardMetricValue };
